//#region Imports
import { useState, useEffect, useRef, Fragment } from "react";
import sharedDatas from "../../businessLogic/sharedDatas";
import gainsightService from "../../businessLogic/gainsightService";
import { ANAG_DUPLICATE_POPUP_BLOCCO_KEY } from "../../businessLogic/bl";
import { useNavigate } from "react-router-dom";
import info from "../../info.json";
//oneFront SDK
import {
  useSnackbar,
  useAuth,
  useTokenData,
  useQuery,
  useMutation,
  useTranslation,
} from "@1f/react-sdk";
//Vapor Components
import { VaporTag } from "@vapor/react-custom/VaporTag";
import { Stack } from "@vapor/react-material/Stack";
import { IconButton } from "@vapor/react-material/IconButton";
import { Dialog } from "@vapor/react-material/Dialog";
import { DialogTitle } from "@vapor/react-material/DialogTitle";
import { DialogContent } from "@vapor/react-material/DialogContent";
import { Typography } from "@vapor/react-material/Typography";
//Custom styles
import {
  chipGreen,
  chipYellow,
  chipOrange,
  chipRed,
} from "../../businessLogic/styles";
//Icons
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
//Contants
import {
    pathFascicoloAdd,
    pathAnagraficaHome,
    pathAnagraficaImportDesktop,
    pathPrestazioneHome,
    pathRischioHome,
    pathFascicoloHome,
} from "../../businessLogic/constants/path";
//Custom components
import { Loading } from "../../components/Loading";
import { ModalVersion } from "../../components/ModalVersion";
import { ModalDelete } from "../../components/ModalDelete";
import { ModalErrorVersion } from "../../components/ModalErrorVersion";
import { ModalFixDuplicate } from "../../components/ModalFixDuplicate";
import { DashboardHeader } from "./components/DashboardHeader";
import { DashboardCharts } from "./components/DashboardCharts";
import { DashboardImport } from "./components/DashboardImport";
import { DashboardExpirations } from "./components/DashboardExpirations";
import { DashboardFascicoli } from "./components/DashboardFascicoli";
//Business Logic
import { monthDiff } from "../../businessLogic/helpers/dateHelpers";
import {
  setLocalStorageSelectedFascicolo,
  setLocalStorageSelectedAutovalutazione,
  setLocalStorageSelectedAzienda,
  setLocalStorageSelectedEntity,
  setLocalStorageImportType,
} from "../../businessLogic/helpers/storageHelpers";
import { bsaSettingsPermission, bsaSettingsNominations, bsaAnagrafica } from "../../businessLogic/constants/securityAreas";
//Models
import { aziendaModel } from "../../businessLogic/models";
import { createAziendaModel, createUserModel } from "../../businessLogic/helpers/modelHelpers";
//Queries
import { query_base_all } from "../../businessLogic/query/baseTablesQueries";
//Mutations
import { mutation_add_audit } from "../../businessLogic/mutations/auditMutations";
//Other components
import postal from "postal";
//Api
import { LogApi } from "../../businessLogic/api/logApi";
import { AnagraficaApi } from "../../businessLogic/api/anagraficaApi";
import { FascicoloApi } from "../../businessLogic/api/fascicoloApi";
import { UserRolesApi } from "../../businessLogic/api/userRolesApi";
import { UserApi } from "../../businessLogic/api/userApi";
import { AricDesktopApi } from "../../businessLogic/api/aricDsektopApi";
import { TenantApi } from "../../businessLogic/api/tenantApi";
import { UserTenantApi } from "../../businessLogic/api/userTenantApi";
import { TsDigitalApi } from "../../businessLogic/api/tsDigitalApi";
import { AziendaApi } from "../../businessLogic/api/aziendaApi";
import { BaseTableApi } from "../../businessLogic/api/baseTableApi";
import { MeteringApi } from "../../businessLogic/api/meteringApi";
import { LastActivityApi } from "../../businessLogic/api/lastActivityApi";
import { AutovalutazioneApi } from "../../businessLogic/api/autovalutazioneApi";
import { PermissionApi } from "../../businessLogic/api/permissionApi";
import { PrestazioniApi } from "../../businessLogic/api/prestazioniApi";
import { RischiApi } from "../../businessLogic/api/rischiApi";
import { SystemMessageApi } from "../../businessLogic/api/systemMeassageApi";
//Helpers
import { Tenanthelpers } from "../../businessLogic/helpers/tenantHelpers";
import { UserHelpers } from "../../businessLogic/helpers/userHelpers";
import { BaseTableHelpers } from "../../businessLogic/helpers/baseTableHelpers";
import { AutovalutazioneHelpers } from "../../businessLogic/helpers/autovalutazioneHelpers";
import { LastActivityHelpers } from "../../businessLogic/helpers/lastActivityHelpers";
import { AnagraficaHelpers } from "../../businessLogic/helpers/anagraficaHelpers";
import { PieChartHelper } from "../../businessLogic/helpers/pieChartHelper";
import { PrestazioneHelpers } from "../../businessLogic/helpers/prestazioneHelpers";
import { RischiHelpers } from "../../businessLogic/helpers/rischiHelpers";
import { FascicoloHelpers } from "../../businessLogic/helpers/fascicoloHelpers";
import { LicenseHelpers, getEffectiveUserPermissions, isTenantReadOnly } from "../../businessLogic/helpers/licenseHelpers";
import { useAreaPermissions } from "../../businessLogic/hooks/useAreaPermissions";

export const Dashboard = ({ basePath }) => {
  const tenantModelDatas = sharedDatas.getPropertyByName("tenantModel");
  const aziendaId = sharedDatas.getPropertyByName("aziendaId");
  const aziendaModelList = sharedDatas.getPropertyByName("aziendaModelList");
  const loggedUserId =  useTokenData("sub");
  const loggedUserModel = sharedDatas.getPropertyByName("userModel")
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { permissions: anagraficaPermissions, getPermissions: getAnagraficaPermissions } = useAreaPermissions(bsaAnagrafica);
  const tenantReadOnly = isTenantReadOnly(tenantModelDatas);

  //#region Api
  const logApi = LogApi();
  const anagraficaApi = AnagraficaApi();
  const fascApi = FascicoloApi();
  const userRolesApi = UserRolesApi();
  const userApi = UserApi();
  const tenantApi = TenantApi();
  const userTenantApi = UserTenantApi();
  const tsDigitalApi = TsDigitalApi();
  const aziendaApi = AziendaApi();
  const baseTableApi = BaseTableApi();
  const meteringApi = MeteringApi();
  const permissionApi = PermissionApi();
  const autovalutazioneApi = AutovalutazioneApi();
  const lastActivityApi = LastActivityApi();
  const prestazioneApi = PrestazioniApi();
  const rischioApi = RischiApi();
  const systemMessageApi = SystemMessageApi();
  //#endregion

  //#region Helpers 
  const tenantHelpers = Tenanthelpers();
  const userHelpers = UserHelpers();
  const baseTableHelpers = BaseTableHelpers();
  const autovalutazioneHelpers = AutovalutazioneHelpers();
  const lastActivityHelpers = LastActivityHelpers()
  const anagraficaHelpers = AnagraficaHelpers();
  const pieChartHelper = PieChartHelper();
  const prestazioneHelpers = PrestazioneHelpers();
  const rischiHelpers = RischiHelpers()
  const fascicoloHelpers = FascicoloHelpers();
  const licenseHelpers = LicenseHelpers();
  //#endRegion

  //#region Query  
  const apiBaseAll = useQuery(
    query_base_all,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  //#endregion

  //#region Mutation
  const apiAddAudit = useMutation(mutation_add_audit, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  //#endregion

  //#region Touch point con TsDigital  
  const [isTokenReady, setIsTokenReady] = useState(false);
  const [tenantId, setTenantId] = useState(sharedDatas.getPropertyByName("tenantId"));
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [isLastVersionModalShow, setIsLastVersionModalShow] = useState(false);
  const [blockingErrorMessage, setBlockingErrorMessage] = useState(null);
  const [isVersionCorrect, setIsVersionCorrect] = useState(true);
  const [message, setMessage] = useState(null);  
  const [accessToken] = useState(useAuth().token);  
  //Recupero l'id del tenant che ha effetuato l'accesso (vale solo nel portale digital) altrimenti lo imposto a mano
  const authSessionData = useAuth();
  let authSessionDataResponse = "";
  let authTenantId = ""
  if (authSessionData.sessionData !== null) {
    authTenantId = authSessionData.sessionData.itemId;
    authSessionDataResponse = JSON.stringify(authSessionData.sessionData);
  } else {
    // Solo dev locale (nessuna sessione Digital): il tenant di bootstrap va
    // fornito via env (app/.env.local, non committato), mai hardcoded nel sorgente.
    authTenantId =
      import.meta.env.VITE_DEV_TENANT_ID ||
      import.meta.env.REACT_APP_DEV_TENANT_ID ||
      "";
  }
  const loadFromTSDigitalStartedRef = useRef(false);
  useEffect(() => {
    if (loadFromTSDigitalStartedRef.current) return;
    loadFromTSDigitalStartedRef.current = true;
    loadFromTSDigital();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTokenReady]);
  async function loadFromTSDigital() {
    console.log(import.meta.env.MODE);
    sharedDatas.setPropertyValue("env", import.meta.env.MODE);
    if(!authTenantId){
      enqueueSnackbar("Nessuna sottoscrizione trovata, riprova",{variant: "error"})
      logApi.AddLog(`Durante la session ${authSessionDataResponse} la procedura non ha trovato nessun tenantId`)
      return
    }
    if (tenantId && tenantModelDatas && aziendaId !== 0 && aziendaModelList !== null && loggedUserId && loggedUserModel) {
      setTenantId(tenantId);
      setUser(loggedUserModel);
      setIsUserLoaded(true);
      setIsTokenReady(true);
    } else {
      //Leggo e setto il tenant corrente
      sharedDatas.setPropertyValue("tenantId", authTenantId);
      setTenantId(sharedDatas.getPropertyByName("tenantId"));  
      try{
        await loadAndSyncTenantFromTsDigital();
      } catch (e) {
        setBackDropOpen(false);
        logApi.AddLog(`${e.message} - Session data : ${authSessionDataResponse}`,e.stack,"loadFromTSDigital/loadAndSyncTenantFromTsDigital","Dashboard");
        setBlockingErrorMessage("Si è verificato un errore durante il caricamento dei dati del tenant da Digital, riprova più tardi");
        return;
      }    
      
      let userItemResponse = await tsDigitalApi.GetUserInfoFromDigital(authTenantId, accessToken, loggedUserId);             
      if(!userItemResponse){
        setBackDropOpen(false);
        logApi.AddLog(`Nessun dato utente recuperato da Digital per l'utente ${loggedUserId} e tenant ${authTenantId} - Session data : ${authSessionDataResponse}`,"","loadFromTSDigital","Dashboard");
        setBlockingErrorMessage("Si è verificato un errore durante il recupero dei dati utente da Digital, riprova più tardi");
        return; 
      }      
      let userModel = null;
      let {userNew, elaboratedAccess} = userHelpers.ProcessRawUserData(userItemResponse, authTenantId,sharedDatas.getPropertyByName("tenantModel"));
      if(userNew){
        try {
          userModel = await SyncUserFromTsDigital(userNew);
        } catch {
          setBackDropOpen(false);
          logApi.AddLog(`Errore durante la sincronizzazione dell'utente da Digital per l'utente ${loggedUserId} e tenant ${authTenantId} - Session data : ${authSessionDataResponse} - UserData : ${JSON.stringify(userNew)}`,"","loadFromTSDigital/SyncUserFromTsDigital","Dashboard");
          setBlockingErrorMessage("Si è verificato un errore durante il caricamento dei dati utente da Digital, riprova più tardi");
          return;
        }
      }
      if(!elaboratedAccess){
        setBackDropOpen(false);
        logApi.AddLog(`L'utente non ha i permessi per poter accedere alla procedura`,"","loadFromTSDigital/ProcessRawUserData","Dashboard");
        setBlockingErrorMessage("Non hai i premessi necessari per accedere alla procedura, rivolgiti all'utente OWNER per la necessaria abilitazione");
        return;
      }
      if(userNew.type !== "OWNER"){
        let hasOwner = await loadUserOwner()
        if(!hasOwner){
          setBackDropOpen(false);
          logApi.AddLog(`L'utente non è di tipo OWNER e non è stato trovato nessun owner per il tenant ${authTenantId} - Session data : ${authSessionDataResponse}`,"","loadFromTSDigital/loaduserOwner","Dashboard");
          setBlockingErrorMessage("Impossibile proseguire, é necessario che l'utente OWNER effettui un primo accesso");
          return;
        }
      }
      let signatureConfig = null;
      try {
        signatureConfig = await tsDigitalApi.GetSignatureConfig(authTenantId, accessToken, loggedUserId);
      } catch (error) {
        logApi.AddLog(error.message, error.stack, "loadFromTSDigital/GetSignatureConfig", "Dashboard");
      }
      sharedDatas.setPropertyValue("hasSignatureCapability", licenseHelpers.checkHasSignatureCapability(signatureConfig));
      let hasArchiveLicense = false;
      try {
        const licenses = await tsDigitalApi.GetSubscriptionInfoFromDigital(authTenantId, accessToken, loggedUserId);
        hasArchiveLicense = licenseHelpers.checkHasArchiveLicense(licenses, authTenantId);
      } catch (error) {
        logApi.AddLog(error.message, error.stack, "loadFromTSDigital/GetSubscriptionInfoFromDigital", "Dashboard");
      }
      sharedDatas.setPropertyValue("hasArchiveLicense", hasArchiveLicense);
      let aziendaId = await loadAndSyncAziendeFromTsigital(userModel);
      if(elaboratedAccess && aziendaId > 0 && accessToken !== ""){
        setIsTokenReady(true);
        //Controllo se è necessario visualizzare la popup che avvisa della nuova versione rilasciata oppure se bloccare l'utente perchè la versione è più vecchia dell'ultimo rilascio
        if (userModel && userModel.lastVersion !== info.version) {
          setIsLastVersionModalShow(true);
        } else {
          setIsUserLoaded(true)
        }
        initGainSight(authTenantId);
      }
    }
  }
  async function loadAndSyncTenantFromTsDigital(){
    let tenantJsonResponse = null;
    let tenantItemResponse = await tsDigitalApi.GetTenantFromDigital(authTenantId, accessToken, loggedUserId); 
    let tenant = tenantHelpers.ProcessRawTenantData(tenantItemResponse); 
    tenantJsonResponse = JSON.stringify(tenantItemResponse)          
    const tenantModel = await tenantApi.UpdateTenantAndGetModel(tenant)
    sharedDatas.setPropertyValue("tenantModel", tenantModel);               
  }
  async function SyncUserFromTsDigital(userNew) {
    sharedDatas.setPropertyValue("userId", loggedUserId);
    try {
      const { userResponse, userTenantResponse } = await userApi.GetUserById(loggedUserId, authTenantId);      
      await upsertUser(userNew, userResponse);    
      await upsertUserTenant(userNew, userTenantResponse);
      return applyUserToSharedState(userNew);
    } catch (e) {
      logApi.AddLog(
        `${e.message} - Session data : ${authSessionDataResponse} - UserData : ${JSON.stringify(userNew)}`,
        e.stack,
        "loadAndSyncUserFromTsDigital",
        "Dashboard"
      );
      throw e;
    }
  }
  async function upsertUser(userNew, existingUser) {
    if (existingUser) {
      userNew.lastVersion = existingUser.LastVersion;
      //PARS-1449: il flag isEnabledToCreateLawyers è impostato manualmente a DB e non arriva da TS Digital.
      //In fase di update va preservato il valore presente a DB, altrimenti verrebbe sovrascritto con il false di default proveniente da Digital.
      userNew.isEnabledToCreateLawyers = existingUser.IsEnabledToCreateLawyers ?? existingUser.isEnabledToCreateLawyers ?? false;
      await userApi.UpdateUser(userNew, authTenantId);
    } else {
      userNew.lastVersion = info.version;
      await userApi.PostUser(userNew);
      logApi.AddLog(`Utente ${userNew.userId} aggiunto con successo`, "", "loadAndSyncUserFromTsDigital/PostUser", "Dashboard", "INFO");
    }
  }
  async function upsertUserTenant(userNew, userTenantResponse) {
    const existing = userTenantResponse ? userTenantResponse.find((x) => x.TenantId === authTenantId) : null;
    if(!existing){
      await userTenantApi.PostUserTenant(userNew);      
    }
    else if (existing) {   
      userNew.tenantTipoId = existing.TenantTipoId;   
      if(existing.Type !== userNew.type){
        await userTenantApi.UpdateUserTenantType(existing, userNew);      
      }
    } 
  }
  function applyUserToSharedState(userNew) {
    const newUserModel = createUserModel(userNew);
    sharedDatas.setPropertyValue("userModel", newUserModel);
    setUser(newUserModel);
    postal.publish({
      channel: "user",
      topic: "user.updatedLoggedUser",
      data: { user: newUserModel },
    });
    return newUserModel;
  }
  async function loadAndSyncAziendeFromTsigital(userModel) {
    let currentAziendaId = 0;
    try {
      const tenantModel = sharedDatas.getPropertyByName("tenantModel");
      const arrAziende = [];
      //Carico le aziende del tenant che ho trovato e le aggiungo se l'utente ha i permessi
      let aziendeResponse = await aziendaApi.GetAziendeByTenant(authTenantId)
      //Fetch unica delle aziende su cui l'utente ha almeno un permesso attivo (no N+1).
      //user_permission non ha colonna tenant: l'intersezione con le aziende del tenant qui sotto garantisce l'isolamento.
      const permittedAziendaIds = await aziendaApi.GetUserPermittedAziendaIds(loggedUserId);
      const isOwner = userModel.type === "OWNER"; //L'ADMIN NON è più nel bypass: vede solo le aziende con permessi espliciti
      for (let i = 0; i < aziendeResponse.length; i++) {
        let azienda = aziendeResponse[i];
        //L'utente vede l'azienda se è OWNER (bypass) o se ha almeno un permesso attivo su di essa
        if (isOwner || permittedAziendaIds.has(azienda.Id)) {
          arrAziende.push(createAziendaModel(azienda, tenantModel));
        }
      }
      //Se non ho trovato aziende con i permessi dell'utente provo a cercare l'azienda con i dati identificativi del tenant e verificare se l'utente ha i permessi su quell'azienda (caso in cui l'azienda non sia stata ancora caricata nel portale ma è presente in anagrafica ts digital)
      if (aziendeResponse.length === 0) {
        const tenantCountry = tenantModel.addrCountry === "IT" ? "ITA" : tenantModel.addrCountry;
        const apiBaseAllResponse = await apiBaseAll.fetch({
          tenantId: authTenantId,
        });
        let basePaese = baseTableApi.GetBasePaese(apiBaseAllResponse)
        let baseProvincia = baseTableApi.GetBaseProvincia(apiBaseAllResponse)
        let baseComune = baseTableApi.GetBaseComune(apiBaseAllResponse)
        const paeseId = baseTableHelpers.FindIdInBaseTableFromIdentificativoOrDefault(basePaese,tenantCountry.toLowerCase())
        const provinciaId = baseTableHelpers.FindIdInBaseTableFromIdentificativoOrDefault(baseProvincia, tenantModel.addrProvince.toLowerCase())
        const comuneId = baseTableHelpers.FindIdInBaseTableFromIdentificativoOrDefault(baseComune, tenantModel.addrCity.toLowerCase())
        let aziendaNew = new aziendaModel(
          0,
          authTenantId,
          tenantModel.name,
          tenantModel.identifier,
          tenantModel.vatNumber,
          paeseId,
          provinciaId,
          tenantModel.addrProvince,
          comuneId,
          tenantModel.addrCity,
          tenantModel.addrStreetName,
          tenantModel.addrStreetNumber,
          tenantModel.addrZipCode,
          null,
          null,
          loggedUserId,
          "",
          0
        );
        let addAziendaResponse = await aziendaApi.PostAzienda(aziendaNew,authTenantId);
        aziendaNew.id = addAziendaResponse.Id;
        arrAziende.push(aziendaNew);
        currentAziendaId = aziendaNew.id;
        sharedDatas.setPropertyValue("aziendaId", aziendaNew.id);
        sharedDatas.setPropertyValue("aziendaName",aziendaNew.denominazione);
        //Aggiungo il consumo sul metering (.value della addConsumptionResponse è lo slotId del metering)
        let addConsumptionResponse = await meteringApi.AddMeteringConsumption(aziendaNew,authTenantId);
        if (addConsumptionResponse.value === 0 || addConsumptionResponse.value === null || addConsumptionResponse.value === undefined) {
          logApi.AddLog(`Consumo non aggiunto correttamente sul metering per l'azienda ${aziendaNew.denominazione} dopo la creazione da TsDigital`, "","loadAndSyncAziendeFromTsigital/AddMeteringConsumption","Dashboard","ERROR")
          enqueueSnackbar(t("error.generale"), { variant: "error" });
        } else {
          aziendaNew.meteringSlotId = addConsumptionResponse.value;
          let aziendaUpdate = await aziendaApi.UpdateAzienda(aziendaNew)
          if(aziendaUpdate){
            logApi.AddLog(`Aggiornato correttamente lo slotid ${aziendaUpdate.MeteringSlotId} per l'azienda ${aziendaUpdate.Denominazione} dopo la creazione da TsDigital`, "","loadAndSyncAziendeFromTsigital/UpdateAziendaMeteringSlotId","Dashboard","INFO")
          }
        }
      } else {
        if (arrAziende.length > 0) {
          const matchedAzienda = arrAziende.find((x) => x.pIva === tenantModel.vatNumber) ?? arrAziende[0];
          currentAziendaId = matchedAzienda.id;
          sharedDatas.setPropertyValue("aziendaId", currentAziendaId);
          sharedDatas.setPropertyValue("aziendaName", matchedAzienda.denominazione || "");
        } else {
          setBackDropOpen(false);
          logApi.AddLog(`L'utente ${loggedUserId} non ha i permessi per accedere a nessuno dei soggetti obbligati del tenant ${authTenantId}`,"","loadAndSyncAziendeFromTsigital/canUserAccess","Dashboard");
          setBlockingErrorMessage("Non hai i permessi per accedere al soggetto obbligato, rivolgiti all'utente con il ruolo di OWNER per la necessaria abilitazione");
        }
      }
      if (arrAziende.length > 0) {
        sharedDatas.setPropertyValue("aziendaModelList", arrAziende);
        postal.publish({
          channel: "azienda",
          topic: "azienda.update",
          data: {
            aziende: arrAziende,
          },
        });  
      }
    } catch (e) {
      logApi.AddLog(e.message,e.stack,"loadAndSyncAziendeFromTsigital","Dashboard");
    }
    return currentAziendaId;
  }
  async function initGainSight(itemId){
    gainsightService.initTag();
    gainsightService.identify({
      tsId: loggedUserId,
      itemId: itemId,
      userModel: sharedDatas.getPropertyByName("userModel"),
      tenantModel: sharedDatas.getPropertyByName("tenantModel"),
    });
  }
  //#endregion

  //#region UseState
  const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
  const [isDataLoaded, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
  const [isPermsLoaded, setIsPermsLoaded] = useState(false);
  //User
  const [user, setUser] = useState(null);
  const [userRespAntiricName, setUserRespAntiricName] = useState("");
  const [respAntiricPermsError, setRespAntiricPermsError] = useState(false);
  const [userOwnerName, setUserOwnerName] = useState("");
  //Autovalutazione
  const [livelloS, setLivelloS] = useState("");
  const [livelloC, setLivelloC] = useState(chipGreen);
  const [, setBsaList] = useState([]); //Contiene il result delle base security areas
  const [, setPermessiList] = useState([]); //Contiene il result dei permessi
  const [entityCounters, setEntityCounters] = useState({
    fascicoli: 0,
    anagrafiche: 0,
    prestazioni: 0,
    valutazioni: 0    
  });
  const [rischiList, setRischiList] = useState([]);
  const [rischiColumns, setRischiColumns] = useState([]);
  const [autovalList, setAutovalList] = useState([]);
  const [autovalColumns, setAutovalColumns] = useState([]);
  const [anagDocInScadList, setAnagDocInScadList] = useState([]);
  const [anagDocInScadListColumns, setAnagDocInScadListColumns] = useState([]);
  const [, setFascicoliTotN] = useState(0);
  const [fascicoliIncompleteList, setFascicoliIncompleteList] = useState([]);
  const [fascicoliIncompleteColumns, setFascicoliIncompleteColumns] = useState([]);
  const [fascicoliCompleteList, setFascicoliCompleteList] = useState([]);
  const [fascicoliCompleteColumns, setFascicoliCompleteColumns] = useState([]);
  const [statsFascicoliData, setStatsFascicoliData] = useState([]);
  const [statsPfPgData, setStatsPfPgData] = useState([]);
  const [statsPrestData, setStatsPrestData] = useState([]);
  const [statsRischiData, setStatsRischiData] = useState([]);
  const [hasMalformedPiva, setHasMalformedPiva] = useState(false);
  const [duplicatesAnags, setDuplicatesAnags] = useState([]);
  const [duplicatesManipulation, setDuplicatesManipulation] = useState({});
  const [isDuplicatesModalVisible, setIsDuplicatesModalVisible] = useState(false);
  const [blockingDuplicates, setBlockingDuplicates] = useState(false);
  const [isDeleteConfirmModalVisible, setIsDeleteConfirmModalVisible] = useState(false);
  const [pendingDeletionData, setPendingDeletionData] = useState(null);
  //#endregion

  //Last Activity
    const [lastActivity, setLastActivity] = useState({
      path: "",
      entityId: "",
      entityName: "",
      area: "",
    });

  //#region Antiriciclaggio Desktop
  const aricDesktopApi = AricDesktopApi();
  const [isARicDesktopActive, setIsARicDesktopActive] = useState(false);
  //#endregion

  //#region Effects
  useEffect(() => {
    setIsPermsLoaded(false);
    setIsDataLoaded(false);
    setEntityCounters((prevState) => ({
      ...prevState,
      fascicoli: 0,
      anagrafiche: 0,
      prestazioni: 0,
      valutazioni: 0
    }));    
    setRischiList([]);
    setRischiColumns([]);
    setAnagDocInScadList([]);
    setAnagDocInScadListColumns([]);
    setFascicoliIncompleteList([]);
    setFascicoliIncompleteColumns([]);
    setFascicoliCompleteList([]);
    setFascicoliCompleteColumns([]);
    setStatsFascicoliData([]);
    setStatsPfPgData([]);
    setStatsPrestData([]);
    setStatsRischiData([]);
    setLastActivity({
      path: "",
      entityId: "",
      entityName: "",
      area: "",
    });
    setBackDropOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedDatas.getPropertyByName("aziendaId")]);

  useEffect(() => {
    if (isUserLoaded) loadPermessi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoaded, isPermsLoaded]);

  useEffect(() => {
    if (isPermsLoaded && !isDataLoaded) loadDatas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermsLoaded, isDataLoaded]);

  // Effect per mostrare la modale duplicati solo quando la dashboard è pronta
  useEffect(() => {    
    if (tenantReadOnly) {
      setIsDuplicatesModalVisible(false);
      setIsDeleteConfirmModalVisible(false);
      setPendingDeletionData(null);
      return;
    }
    const pendingDuplicates = sharedDatas.getPropertyByName("pendingDuplicates");
    if (isUserLoaded && isDataLoaded) {
      if (pendingDuplicates && pendingDuplicates.length > 0) {
        setDuplicatesAnags(pendingDuplicates);
        if (blockingDuplicates) {
          // Popup bloccante: mostra sempre e tieni aperta, ignorando "già mostrato" e la modale di versione.
          setIsDuplicatesModalVisible(true);
        } else {
          const duplicatesModalAlreadyShown = sharedDatas.getPropertyByName("duplicatesModalAlreadyShown");
          if (!isLastVersionModalShow && !duplicatesModalAlreadyShown) {
            setTimeout(() => {setIsDuplicatesModalVisible(true);}, 500);
          }
        }
      } else {
        setDuplicatesAnags([]);
        setIsDuplicatesModalVisible(false);
      }
    }
  }, [isUserLoaded, isDataLoaded, isLastVersionModalShow, blockingDuplicates, tenantReadOnly]);
  //#endregion

  //#region Load Functions
  const loadPermessi = async () => {
    try {
      if (isTokenReady && isUserLoaded && !isPermsLoaded) {
        //Solo l'OWNER ha di default tutti i permessi; ADMIN e altri ruoli vedono/operano solo dove un OWNER ha assegnato permessi espliciti
        const userModel = sharedDatas.getPropertyByName("userModel");
        if (!userModel) {
          return;
        }
        const userRole = userModel.type;
        const isOwner = userRole === "OWNER";
        const canRead = isOwner, canCreate = isOwner, canUpdate = isOwner, canDelete = isOwner;
        let permessiList = [];
        if (sharedDatas.getPropertyByName("userPermissions") !== null) {
          permessiList = sharedDatas.getPropertyByName("userPermissions").filter((x) => x.aziendaId === aziendaId);
        }
        if (permessiList.length === 0) {
          let allAreaItems = await permissionApi.GetBaseSecurityAreas();          
          setBsaList(allAreaItems);
          
          let userPermsCount = await permissionApi.GetUserPermissionsCount(loggedUserId, aziendaId);
          const hasUserPermissions = userPermsCount > 0;
          const hasAllUserPermissions = userPermsCount === allAreaItems.length;
          let userPermissions = await permissionApi.GetUserPermissions(loggedUserId, aziendaId,allAreaItems);         
          if (!hasAllUserPermissions) {
            var alreadyPermittedArea = userPermissions.map((item) => item.area);
            var permsMissing = allAreaItems.filter((item) => !alreadyPermittedArea.includes(item.key));
            let addedPermissions = [];
            for (let i = 0; i < permsMissing.length; i++) {
              const element = permsMissing[i];
              let postedPermission = await permissionApi.PostUserPermission(loggedUserId, aziendaId, element.key, canRead, canCreate, canUpdate, canDelete, allAreaItems)
              if (postedPermission) {
                addedPermissions.push(postedPermission);
                apiAddAudit.fetch({
                  tenantId: tenantId,
                  aziendaId: aziendaId,
                  area: bsaSettingsPermission,
                  operation: "Create",
                  entityType: "user_permission",
                  entityId: postedPermission.id.toString(),
                  oldValues: "",
                  newValues: JSON.stringify(postedPermission),
                });
              }
            }            
            if(addedPermissions.length > 0){
              addedPermissions.forEach((permission) => {
                userPermissions.push(permission);
              });
            }
          }
          permessiList = userPermissions;
        }
        if (permessiList.length > 0) {
          const effectivePermissions = getEffectiveUserPermissions(
            permessiList,
            sharedDatas.getPropertyByName("tenantModel")
          );
          sharedDatas.setPropertyValue("userPermissions", effectivePermissions);
          setPermessiList(effectivePermissions);
          setIsPermsLoaded(true);
        }
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "loadPermessi", "Dashboard");
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const loadDatas = async () => {
    try {
      if (isTokenReady && isPermsLoaded && isUserLoaded && !isDataLoaded) {
        let hasOwner = await loadUserOwner();
        if (!hasOwner) {
          await syncUserOwner();
          hasOwner = await loadUserOwner();
        }
        if (hasOwner) {
          sharedDatas.setPropertyValue("version", info.version);
          await loadEnvironmentSettings();      
          await loadLastAutovalutazione();
          await loadResponsabileAntiriciclaggio();                                     
          let {arrPaeseItems, arrProvinceItems} = await loadCountriesAndProvinces();
          await loadUserLastActivity();
          await loadMalformedPivaAnagrafica();
          await loadLivelloRischioAnagraficheStats(arrPaeseItems, arrProvinceItems);
          await loadPPEAnagraficheStats();
          await loadLivelloRischioPrestazioniStats();      
          await loadLivelloEFTotaleStats();
          await loadAnagraficheDocInScadenza();
          await loadRischiInScadenza();
          await loadAutovalutazioniInScadenza();
          await loadFascicoli();
          await loadAricDesktopLicense();
          await loadSystemMessageAndVersion();
          await checkAndLoadDuplicates();  
          setIsDataLoaded(true);
          setBackDropOpen(false);
          gainsightService.track("AML_Dashboard_Success");
        } else {
          setBackDropOpen(false);
          logApi.AddLog(`L'utente OWNER del tenant ${tenantId}- azienda : ${aziendaId} non ha ancora effettuato l'accesso per completare la configurazione iniziale`, "","checkOWNERhadAccess","Dashboard");
          setBlockingErrorMessage("La procedura non è ancora pronta per l'utilizzo, l'utente OWNER del tenant non ha ancora effettuato l'accesso per completare la configurazione iniziale, riprova più tardi");        
        } 
      }               
    } catch (e) {
      setBackDropOpen(false);
      logApi.AddLog(e.message, e.stack, "loadDatas", "Dashboard");
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const loadEnvironmentSettings = async () => {
    try {
      let currentEnvironment = await baseTableApi.GetBaseAppSetting("environment");      
      if (currentEnvironment){
        sharedDatas.setPropertyValue("environment", currentEnvironment);
      } 
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle impostazioni dell'ambiente: " + error.message, error.stack, "loadEnvironmentSettings", "Dashboard");
      throw new Error("Errore nel caricamento delle impostazioni dell'ambiente: " + error.message);
    }
  }
  const loadLastAutovalutazione = async () => {
    try {
      if (user.tenantTipoId !== 3) {
        let lastAutovalutazioneResponse = await autovalutazioneApi.GetLastAutovalutazione(tenantId, aziendaId);    
        let {livelloS, livelloC } = autovalutazioneHelpers.GetLivelloRischioAndColorByAutovalutazione(lastAutovalutazioneResponse);      
        setLivelloS(livelloS);
        setLivelloC(livelloC);          
      } else if (user.tenantTipoId === 3) {
        const lastAutovalutazioneAvvocatiResponse = await autovalutazioneApi.GetLastAutovalutazioneAvvocati(tenantId, aziendaId);         
        let { livelloS, livelloC } = autovalutazioneHelpers.GetLivelloRischioAndColorByAutovalutazioneAvvocati(lastAutovalutazioneAvvocatiResponse);
        setLivelloS(livelloS);
        setLivelloC(livelloC);
      }   
    } catch (error) {
      //Controllo reso non bloccante: un errore sul livello di rischio non deve impedire l'atterraggio della dashboard
      const fallback = user.tenantTipoId === 3
        ? autovalutazioneHelpers.GetLivelloRischioAndColorByAutovalutazioneAvvocati(null)
        : autovalutazioneHelpers.GetLivelloRischioAndColorByAutovalutazione(null);
      setLivelloS(fallback.livelloS);
      setLivelloC(fallback.livelloC);
      logApi.AddLog("Errore nel caricamento dell'ultima autovalutazione: " + error.message, error.stack, "loadLastAutovalutazione", "Dashboard");
    }
  }
  const loadResponsabileAntiriciclaggio = async () => {
    try {
      //Controllo preventivo: se l'utente non ha il permesso di lettura sulle nomine non provo nemmeno a leggere i ruoli
      //(la GetUserRoles fallirebbe) ed evito di bloccare l'intera dashboard, segnalando la mancanza di permessi in header
      const userPermissions = sharedDatas.getPropertyByName("userPermissions");
      const nominationsPermission = userPermissions ? userPermissions.find((x) => x.area === bsaSettingsNominations) : null;
      if (!nominationsPermission || !nominationsPermission.canRead) {
        setRespAntiricPermsError(true);
        setUserRespAntiricName("");
        logApi.AddLog("L'utente non ha i permessi per leggere i ruoli dell'azienda, caricamento del responsabile antiriciclaggio saltato", "", "loadResponsabileAntiriciclaggio", "Dashboard", "INFO");
        return;
      }
      setRespAntiricPermsError(false);
      const rolesResponse = await userRolesApi.GetUserRoles()
      let respAntiric = rolesResponse.find(roleUser => roleUser.role === "responsabile_antiriciclaggio" && (roleUser.dateEnd === null || new Date(roleUser.dateEnd) > new Date()));
      if(respAntiric && respAntiric.userId){
        const { userResponse } = await userApi.GetUserById(respAntiric.userId)
        setUserRespAntiricName(userResponse.Name + " " + userResponse.Surname);
      } else {
        setUserRespAntiricName("");
      }
    } catch (error) {
      //Controllo reso non bloccante: in caso di errore segnalo in header ma continuo con il caricamento della dashboard
      setRespAntiricPermsError(true);
      setUserRespAntiricName("");
      logApi.AddLog("Errore nel caricamento del responsabile antiriciclaggio: " + error.message, error.stack, "loadResponsabileAntiriciclaggio", "Dashboard");
    }
  }
  const loadUserOwner = async () => {
    try {
      const userOwnerResponse = await userApi.GetOwnerByTenantId(authTenantId)
      if(userOwnerResponse){
        setUserOwnerName(userOwnerResponse.user.Email);
        return true
      }
      return false   
    } catch (error) {
      logApi.AddLog("Errore nel caricamento dell'owner del tenant: " + error.message, error.stack, "loadUserOwner", "Dashboard");
      throw new Error("Errore nel caricamento dell'owner del tenant: " + error.message);
    }
  }
  const loadCountriesAndProvinces = async () => {
    try {
      const apiBaseAllResponse = await apiBaseAll.fetch({
        tenantId: tenantId,
      });   
      let arrPaeseItems = baseTableApi.GetBasePaese(apiBaseAllResponse);
      let arrProvinceItems = baseTableApi.GetBaseProvincia(apiBaseAllResponse);
      return { arrPaeseItems, arrProvinceItems}
    } catch (error) {
      logApi.AddLog("Errore nel caricamento di paesi e province: " + error.message, error.stack, "loadCountriesAndProvinces", "Dashboard");
      throw new Error("Errore nel caricamento di paesi e province: " + error.message); 
    }
  }
  const loadUserLastActivity = async () => {
    try {
      const lastActivityResponse = await lastActivityApi.GetLastActivity(tenantId, aziendaId, loggedUserId);        
      if (lastActivityResponse) {
        let area = lastActivityHelpers.GetLastActivityAreaByPath(lastActivityResponse.Path);          
        setLastActivity((prevState) => ({
          ...prevState,
          path: lastActivityResponse.Path,
          entityId: lastActivityResponse.EntityId,
          entityName: lastActivityResponse.EntityName,
          area: area,
        }));
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento dell'ultima attività dell'utente: " + error.message, error.stack, "loadUserLastActivity", "Dashboard");
      throw new Error("Errore nel caricamento dell'ultima attività dell'utente: " + error.message);
    }
  }
  const loadMalformedPivaAnagrafica = async () => {
    try {
      let toCorrectAnag = await anagraficaApi.GetMalformedPivaAnagrafica(tenantId, aziendaId);
      let hasMalformedPiva = toCorrectAnag.length > 0;
      setHasMalformedPiva(hasMalformedPiva);
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle anagrafiche con partita IVA malformata: " + error.message, error.stack, "loadMalformedPivaAnagrafica", "Dashboard");
      throw new Error("Errore nel caricamento delle anagrafiche con partita IVA malformata: " + error.message);
    }
  }
  const loadLivelloRischioAnagraficheStats = async (arrPaeseItems, arrProvinceItems) => {
    try {
      let statsArrRischioAnagrafiche = [];
      let nRischioAnagrafiche = 0;
      let rischioGeo1 = 0; let rischioGeo2 = 0; let rischioGeo3 = 0; let rischioGeo4 = 0;
      const distinctRischioAnagrafiche = await anagraficaApi.GetDistinctRischioAnagStats(tenantId, aziendaId);
      if(distinctRischioAnagrafiche.length > 0){
        ({rischioGeo1, rischioGeo2, rischioGeo3, rischioGeo4} = anagraficaHelpers.CountRischioGeograficoCategoryFromArray(distinctRischioAnagrafiche, arrPaeseItems, arrProvinceItems));        
        nRischioAnagrafiche = distinctRischioAnagrafiche.length;
      }        
      let rawDatas = [
        {
          name: t("valutazione.form.rischioInerenteLivello1"),
          value: rischioGeo1,
          fill: "#91D250",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello2"),
          value: rischioGeo2,
          fill: "#F1DA21",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello3"),
          value: rischioGeo3,
          fill: "#FEBF00",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello4"),
          value: rischioGeo4,
          fill: "#FF0002",
        },
      ]
      statsArrRischioAnagrafiche = pieChartHelper.CalculatePieChartData(rawDatas, nRischioAnagrafiche);        
      setEntityCounters((prevState) => ({
        ...prevState,
        fascicoli: nRischioAnagrafiche,
      }));                
      if (nRischioAnagrafiche > 0 && statsArrRischioAnagrafiche.length > 0) {
        setStatsFascicoliData(statsArrRischioAnagrafiche);
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle statistiche del livello di rischio geografico delle anagrafiche: " + error.message, error.stack, "loadLivelloRischioAnagraficheStats", "Dashboard");
      throw new Error("Errore nel caricamento delle statistiche del livello di rischio geografico delle anagrafiche: " + error.message);
    }
  }
  const loadPPEAnagraficheStats = async () => {
    try {
      let statsArrPPEAnagrafiche = [];
      let nPPEAnagrafiche = 0;
      let ppe1 = 0; let ppe2 = 0; let ppe3 = 0;
      const distinctPPEAnagrafiche = await anagraficaApi.GetDistinctPPEAnagStats(tenantId, aziendaId);        
      if(distinctPPEAnagrafiche.length > 0){
        ({ppe1, ppe2, ppe3} = anagraficaHelpers.CountPPECategoryFromArray(distinctPPEAnagrafiche));
        nPPEAnagrafiche = distinctPPEAnagrafiche.length;
      }
      let rawDatasPPE = [
        {
          name: "E' una PPE",
          value: ppe1,
          fill: "#ff0002",
        },
        {
          name: "Non è una PPE",
          value: ppe2,
          fill: "#91d250",
        },
        {
          name: "Non è una PPE da più di un anno",
          value: ppe3,
          fill: "#febf00",
        },
      ]
      statsArrPPEAnagrafiche = pieChartHelper.CalculatePieChartData(rawDatasPPE, nPPEAnagrafiche);
      setEntityCounters((prevState) => ({
        ...prevState,
        anagrafiche: nPPEAnagrafiche,
      }));
      if ( nPPEAnagrafiche > 0 && statsArrPPEAnagrafiche.length > 0) {
        setStatsPfPgData(statsArrPPEAnagrafiche);
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle statistiche delle PPE delle anagrafiche: " + error.message, error.stack, "loadPPEAnagraficheStats", "Dashboard");
      throw new Error("Errore nel caricamento delle statistiche delle PPE delle anagrafiche: " + error.message);
    }
  }
  const loadLivelloRischioPrestazioniStats = async () => {
    try {
      let statsArrPrest = [];
      let nRischioPrest = 0;
      let rischioPrest1 = 0; let rischioPrest2 = 0; let rischioPrest3 = 0; let rischioPrest4 = 0;
      const prestazioniStats = await prestazioneApi.GetPrestazioniRischioStats(tenantId, aziendaId);
      if(prestazioniStats.length > 0){
        ({rischioPrest1, rischioPrest2, rischioPrest3, rischioPrest4} = prestazioneHelpers.CountPrestazioneLivelliRischio(prestazioniStats));
        nRischioPrest = prestazioniStats.length;
      }
      let rawDatasPrest = [
        {
          name: t("valutazione.form.rischioInerenteLivello1"),
          value: rischioPrest1,
          fill: "#91D250",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello2"),
          value: rischioPrest2,
          fill: "#F1DA21",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello3"),
          value: rischioPrest3,
          fill: "#FEBF00",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello4"),
          value: rischioPrest4,
          fill: "#FF0002",
        },
      ]
      statsArrPrest = pieChartHelper.CalculatePieChartData(rawDatasPrest, nRischioPrest);        
      setEntityCounters((prevState) => ({
        ...prevState,
        prestazioni: nRischioPrest,
      }));        

      if ( nRischioPrest > 0 && statsArrPrest.length > 0) {
        setStatsPrestData(statsArrPrest);
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle statistiche del livello di rischio delle prestazioni: " + error.message, error.stack, "loadLivelloRischioPrestazioniStats", "Dashboard");
      throw new Error("Errore nel caricamento delle statistiche del livello di rischio delle prestazioni: " + error.message);
    }
  }
  const loadLivelloEFTotaleStats = async () => {
    try {
      let statsArrRischi = [];
      let nRischioEff = 0;
      let rischioEff1 = 0;let rischioEff2 = 0;let rischioEff3 = 0;let rischioEff4 = 0;
      const rischiStats = await rischioApi.GetRischioLivelloStats(tenantId, aziendaId);
      if(rischiStats.length > 0){
        ({rischioEff1, rischioEff2, rischioEff3, rischioEff4} = rischiHelpers.CountRischiLivelloStats(rischiStats));
        nRischioEff = rischiStats.length;
      }
      let rawDatasRischi = [
        {
          name: t("valutazione.form.rischioInerenteLivello1"),
          value: rischioEff1,
          fill: "#91D250",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello2"),
          value: rischioEff2,
          fill: "#F1DA21",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello3"),
          value: rischioEff3,
          fill: "#FEBF00",
        },
        {
          name: t("valutazione.form.rischioInerenteLivello4"),
          value: rischioEff4,
          fill: "#FF0002",
        },
      ]
      statsArrRischi = pieChartHelper.CalculatePieChartData(rawDatasRischi, nRischioEff);
      setEntityCounters((prevState) => ({
        ...prevState,
        valutazioni: nRischioEff,
      }));        
      if (nRischioEff > 0 && statsArrRischi.length > 0) {
        setStatsRischiData(statsArrRischi);
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle statistiche del livello di rischio effettivo: " + error.message, error.stack, "loadLivelloRischioEffettivoStats", "Dashboard");
      throw new Error("Errore nel caricamento delle statistiche del livello di rischio effettivo: " + error.message);
    }
  }
  const loadAnagraficheDocInScadenza = async () => {
    try{
      let anagDocInScadArr = [];
      const anagDocScad = await anagraficaApi.GetAnagraficheFascicoliDocScad(tenantId, aziendaId);
      if(anagDocScad.length > 0){
        let fascicoliAttivi = fascicoloHelpers.GetFascicoliAttivi(anagDocScad);
        anagDocInScadArr = fascicoloHelpers.GetAnagraficheDocInScadenzaFromFrascicoli(fascicoliAttivi)
      }
      setAnagDocInScadList(anagDocInScadArr);
      setAnagDocInScadListColumns([
        { field: "id", headerName: "Id", flex: 0.2, type: "number" },
        {
          field: "date",
          headerName: "Scade il",
          flex: 0.5,
          valueFormatter: (params) => {
            if (params.value == null) {
              return "";
            }
            return new Date(params.value).toLocaleDateString();
          },
        },
        {
          field: "denominazione",
          headerName: "Denominazione",
          flex: 0.8,
          editable: false,
        },
        {
          field: "scaduto",
          headerName: "Scade tra",
          flex: 0.8,
          editable: false,
          renderCell: (params) => renderColorCell(params.row.date),
          valueGetter: (params) => renderColorCellGetter(params.row.date),
        },
        {
          field: "actions",
          headerName: "",
          flex: 0.1,
          filterable: false,
          renderCell: (params) =>
            renderAnagDocInScadDetailsButton(params.row),
        },
      ]);
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle anagrafiche con documenti in scadenza: " + error.message, error.stack, "loadAnagraficheDocInScadenza", "Dashboard");
      throw new Error("Errore nel caricamento delle anagrafiche con documenti in scadenza: " + error.message);
    }
  }
  const loadRischiInScadenza = async () => {
    try {
      let rischiResponse = await rischioApi.GetRischiByDataControlloCostante();
      setRischiList(rischiResponse);
      setRischiColumns([
        { field: "id", headerName: "Id", type: "number", flex: 0.2 },
        {
          field: "date",
          headerName: "Prossima verifica",
          flex: 0.5,
          valueFormatter: (params) => {
            if (params.value == null) {
              return "";
            }
            return new Date(params.value).toLocaleDateString();
          },
        },
        { field: "fascicoloName", headerName: "Nome", flex: 1 },
        {
          field: "scaduto",
          headerName: "Scade tra",
          flex: 0.8,
          editable: false,
          renderCell: (params) => renderColorCell(params.row.date),
          valueGetter: (params) => renderColorCellGetter(params.row.date),
        },
        {
          field: "actions",
          headerName: "",
          flex: 0.2,
          filterable: false,
          renderCell: (params) => renderRischiDetailsButton(params.row),
        },
      ]);
    } catch (error) {
      logApi.AddLog("Errore nel caricamento dei rischi in scadenza: " + error.message, error.stack, "loadRischiInScadenza", "Dashboard");
      throw new Error("Errore nel caricamento dei rischi in scadenza: " + error.message);
    }
  }
  const loadAutovalutazioniInScadenza = async () => {
    try {
      let responseDatas = null;
      if (user.tenantTipoId !== 3) {
        responseDatas = await autovalutazioneApi.GetAutovlautazioniByExpire(tenantId,aziendaId)
      } else if (user.tenantTipoId === 3) {
        responseDatas = await autovalutazioneApi.GetAutovlautazioniAvvocatiByExpire(tenantId,aziendaId)
      }
      let autovalArr = [];
      if (responseDatas !== null && responseDatas.length > 0) {
        responseDatas.forEach(async (autoval) => {
          const { userResponse } = await userApi.GetUserById(user && user.tenantTipoId === 3 ? autoval.ProvdedBy : autoval.ProvidedBy, tenantId)            
          let autovalutazione = autovalutazioneHelpers.GetAutovlutazioneExpire(autoval,userResponse)
          autovalArr.push(autovalutazione)
        });
        setAutovalList(autovalArr);
        setAutovalColumns([
          { field: "id", headerName: "Id", type: "number", flex: 0.2 },
          {
            field: "creationDate",
            headerName: "Data di creazione",
            flex: 0.5,
            valueFormatter: (params) => {
              if (params.value == null) {
                return "";
              }
              return new Date(params.value).toLocaleDateString();
            },
          },
          {
            field: "expireDate",
            headerName: "Data scadenza",
            flex: 0.5,
            valueFormatter: (params) => {
              if (params.value == null) {
                return "";
              }
              return new Date(params.value).toLocaleDateString();
            },
          },
          {
            field: "providedBy",
            headerName: "Autore autovalutazione",
            flex: 0.5,
          },
          {
            field: "scaduto",
            headerName: "Scade tra",
            flex: 0.8,
            editable: false,
            renderCell: (params) => renderColorCell(params.row.expireDate),
            valueGetter: (params) =>
              renderColorCellGetter(params.row.expireDate),
          },
        ]);
      }
    } catch (error) {
      logApi.AddLog("Errore nel caricamento delle autovalutazioni in scadenza: " + error.message, error.stack, "loadAutovalutazioniInScadenza", "Dashboard");
      throw new Error("Errore nel caricamento delle autovalutazioni in scadenza: " + error.message);
    }
  }
  const loadFascicoli = async () => {
    try {
      const fascicoliResponse = await fascApi.GetFascicoliAndRelatedEntities(tenantId,false,true,null)        
      setFascicoliTotN(fascicoliResponse.fascicoliCount);
      let {fascicoliComplete, fascicoliIncomplete} = fascicoloHelpers.GetCopmleteAndIncompleteFascicoliModel(fascicoliResponse.fascicoli,tenantId,aziendaId)
      setFascicoliIncompleteList(fascicoliIncomplete);
      setFascicoliIncompleteColumns([
        {
          field: "id",
          headerName: "Id",
          type: "number",
          flex: 0.2,
        },
        {
          field: "date",
          headerName: t("autovalutazione.form.data"),
          flex: 0.5,
          valueFormatter: (params) => {
            if (params.value == null) {
              return "";
            }
            return new Date(params.value).toLocaleDateString();
          },
        },
        {
          field: "status",
          headerName: "Status",
          flex: 1,
          valueFormatter: (params) =>
            params.row && params.row.statusReasons && typeof params.row.statusReasons === 'string' && params.row.statusReasons.includes("Cliente non presente")
              ? "Cliente mancante, eliminare il fascicolo"
              : "Incompleto",
        },
        { field: "name", headerName: "Intestazione", flex: 1 },
        {
          field: "actions",
          headerName: "",
          flex: 0.2,
          filterable: false,
          renderCell: (params) =>
            renderFascicoliIncompletiDetailsButton(params.row),
        },
      ]);
      setFascicoliCompleteList(fascicoliComplete);
      setFascicoliCompleteColumns([
        {
          field: "id",
          headerName: "Id",
          type: "number",
          flex: 0.2,
        },
        {
          field: "date",
          headerName: t("autovalutazione.form.data"),
          flex: 0.5,
          valueFormatter: (params) => {
            if (params.value == null) {
              return "";
            }
            return new Date(params.value).toLocaleDateString();
          },
        },
        {
          field: "status",
          headerName: "Status",
          flex: 1,
          valueFormatter: (params) =>
            params.row && params.row.statusReasons && typeof params.row.statusReasons === 'string' && params.row.statusReasons.includes("Cliente non presente")
              ? "Cliente mancante, eliminare il fascicolo"
              : "Completo",
        },
        { field: "name", headerName: "Intestazione", flex: 1 },
        {
          field: "actions",
          headerName: "",
          flex: 0.2,
          filterable: false,
          renderCell: (params) =>
            renderFascicoliIncompletiDetailsButton(params.row),
        },
      ]);
    } catch (error) {
      // Errore non bloccante: se i fascicoli non vengono recuperati (es. permessi mancanti)
      // il bootstrap della dashboard deve comunque completare. Atterrando nell'area fascicoli
      // l'utente vedrà la schermata NotAuth.
      logApi.AddLog("Errore nel caricamento dei fascicoli: " + error.message, error.stack, "loadFascicoli", "Dashboard");
    }
  }
  const loadAricDesktopLicense = async () => {
    try {
      let aricLicenseActive = await aricDesktopApi.CheckAricDesktopLicense();
      setIsARicDesktopActive(aricLicenseActive);
    } catch (e) {
      logApi.AddLog("Errore nel caricamento della licenza ARic Desktop: " + e.message, e.stack, "loadAricDesktopLicense", "Dashboard");      
    }
  }
  const loadSystemMessageAndVersion = async () => {
    try {
      let responseMessage = await systemMessageApi.GetLastSystemMessage();
      if (responseMessage) {
        setMessage(responseMessage);
      }
      if (responseMessage.Version !== info.version) {
        setIsVersionCorrect(false);
      }
    } catch (error) {
        logApi.AddLog("Errore nel caricamento del messaggio di sistema e controllo versione: " + error.message, error.stack, "loadSystemMessageAndVersion", "Dashboard");
        throw new Error("Errore nel caricamento del messaggio di sistema e controllo versione: " + error.message);
    }
  }
  const syncUserOwner = async () => {
    try {
      let allUserTenant = await userTenantApi.GetAllUserTenant(authTenantId)
      for (let i = 0; i < allUserTenant.length; i++) {
        let userTenant = allUserTenant[i];
        if(userTenant.UserId){
          let digitalResp = await tsDigitalApi.GetUserInfoFromDigital(authTenantId, accessToken, userTenant.UserId)
          if(digitalResp && digitalResp.roles.find(r=> r.actionKey === "OWNER" &&  r.resourceUuid === authTenantId &&  (r.appId === "AML" || r.appId === null))){
            let itemTenant = {tenantId: authTenantId, userId: userTenant.UserId}
            let itemUser = {tenantTipoId: userTenant.TenantTipoId, type: "OWNER"}
            await userTenantApi.UpdateUserTenant(itemTenant,itemUser)
          }
        }
      }
    } catch (error) {
      logApi.AddLog(`Errore durante la sincronizzazione dell'owner sul tenant ${authTenantId}: ` + error.message, error.stack, "syncUserOwner", "Dashboard");
      throw new Error(`Errore durante la sincronizzazione dell'owner sul tenant ${authTenantId}: ` + error.message);
    }
  }
  const checkAndLoadDuplicates = async () => {
    try {
      if (isTenantReadOnly(sharedDatas.getPropertyByName("tenantModel"))) {
        sharedDatas.setPropertyValue("pendingDuplicates", null);
        setBlockingDuplicates(false);
        return;
      }
      let checkDuplicateResponse = await anagraficaApi.CheckIfThereAreDuplicates();
      setDuplicatesManipulation(checkDuplicateResponse);
      if (checkDuplicateResponse.authorized) {
        let allDuplicates = await anagraficaApi.GetDuplicateAnagrafica()
        if (allDuplicates && allDuplicates.length > 0) {
          sharedDatas.setPropertyValue("pendingDuplicates", allDuplicates);
          // Modello "default globale + override per tenant": determina se il popup deve essere bloccante.
          // Se non esiste alcun record viene creato il default globale (TenantId null) con valore "true".
          let popupBloccoValue = await baseTableApi.ResolveBaseAppSetting(ANAG_DUPLICATE_POPUP_BLOCCO_KEY, tenantId);
          setBlockingDuplicates(popupBloccoValue === true);
        } else {
          sharedDatas.setPropertyValue("pendingDuplicates", null);
          setBlockingDuplicates(false);
        }
      }
    } catch (error) {
      logApi.AddLog("Errore nel controllo e caricamento delle anagrafiche duplicate: " + error.message, error.stack, "checkAndLoadDuplicates", "Dashboard");
      throw new Error("Errore nel controllo e caricamento delle anagrafiche duplicate: " + error.message);
    }
  }
  //#endregion

  //#region Renders
  const renderColorCell = (date) => {
    let currentDate = new Date();
    let monthsDiff = monthDiff(currentDate, new Date(date));
    if (monthsDiff > 3) {
      //Verde
      return (
        <VaporTag
          variant="standard"
          label="Scade entro 6 mesi"
          sx={chipGreen}
        />
      );
    } else if (monthsDiff > 1 && monthsDiff <= 3) {
      //Giallo
      return (
        <VaporTag
          variant="standard"
          label="Scade entro 3 mesi"
          sx={chipYellow}
        />
      );
    } else if (monthsDiff === 0 || monthsDiff === 1) {
      //Arancione
      return (
        <VaporTag
          variant="standard"
          label="Scade entro 1 mese"
          sx={chipOrange}
        />
      );
    } else if (monthsDiff < 0) {
      //Rosso
      return <VaporTag variant="standard" label="Scaduto" sx={chipRed} />;
    }
  };
  const renderColorCellGetter = (date) => {
    let currentDate = new Date();
    let monthsDiff = monthDiff(currentDate, new Date(date));
    if (monthsDiff > 3) {
      //Verde
      return "Scade entro 6 mesi";
    } else if (monthsDiff > 1 && monthsDiff <= 3) {
      //Giallo
      return "Scade entro 3 mesi";
    } else if (monthsDiff === 0 || monthsDiff === 1) {
      //Rosso
      return "Scade entro 1 mese";
    } else if (monthsDiff < 0) {
      return "Scaduto";
    }
  };
  const renderAnagDocInScadDetailsButton = (item) => {
    return (
      <IconButton
        color="primary"
        onClick={(e) => handleGoToAnagrafica(e, item)}
      >
        <ArrowForwardIcon />
      </IconButton>
    );
  };
  const renderRischiDetailsButton = (item) => {
    return (
      <IconButton color="primary" onClick={(e) => handleGoToRischio(e, item)}>
        <ArrowForwardIcon />
      </IconButton>
    );
  };
  const renderFascicoliIncompletiDetailsButton = (item) => {
    return (
      <IconButton color="primary" onClick={(e) => handleGoToFascicolo(e, item)}>
        <ArrowForwardIcon />
      </IconButton>
    );
  };
  //#endregion

  //#region Handler
  const handleLastActivityClick = () => {
    lastActivityHelpers.NavigateFromLastActivity(lastActivity, navigate, {
      setSelectedAzienda: setLocalStorageSelectedAzienda,
      setSelectedFascicolo: setLocalStorageSelectedFascicolo,
      setSelectedAutovalutazione: setLocalStorageSelectedAutovalutazione,
    });
  };
  const handleGoToFascicoloHome = () => {
    navigate(pathFascicoloHome);
  };
  const handleGoToAnagraficaHome = () => {
    navigate(pathAnagraficaHome);
  };
  const handleGoToPrestazioneHome = () => {
    navigate(pathPrestazioneHome);
  };
  const handleGoToValutazioneHome = () => {
    navigate(pathRischioHome);
  };
  const handleGoToImportDesktop = (type) => {
    setLocalStorageImportType(type);
    navigate(pathAnagraficaImportDesktop);
  };
  const handleGoToAnagrafica = async (event, item) => {
    try {
      event.stopPropagation();
      setLocalStorageSelectedFascicolo(parseInt(item.fascicoloId));
      setLocalStorageSelectedEntity("anagrafica", item.id);
      navigate(pathFascicoloAdd);
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleGoToAnagrafica", "Dashboard");
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const handleGoToRischio = async (event, item) => {
    try {
      event.stopPropagation();
      setLocalStorageSelectedFascicolo(parseInt(item.fascicoloId));
      setLocalStorageSelectedEntity("rischio", item.id);
      navigate(pathFascicoloAdd);
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleGoToAnagrafica", "Dashboard");
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const handleGoToFascicolo = async (event, item) => {
    try {
      event.stopPropagation();
      setLocalStorageSelectedFascicolo(parseInt(item.id));
      navigate(pathFascicoloAdd);
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleGoToFascicolo", "Dashboard");
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const handleGoToErrAnag = async (event, item) => {
    event.stopPropagation();
    navigate(pathAnagraficaHome, { state: { activeTab: 'tabErrate' } });
  };
  //#endregion

  //#region Modal Version
  const handleModalVersionClose = () => {
    setIsLastVersionModalShow(false);
    setIsUserLoaded(true);
  };
  const handleModalVersionOk = async () => {
    let currentUserModel = sharedDatas.getPropertyByName("userModel");    
    try {
      currentUserModel.lastVersion = info.version;
      let updateUserResponse = await userApi.UpdateUser(currentUserModel,authTenantId)
      if(updateUserResponse){
        setIsUserLoaded(true);
        logApi.AddLog(`Versione ${info.version} correttamente aggiornata  sull'utente ${currentUserModel.userId}`,"","handleModalOkVersion","Dashboard","INFO")
      }
    } catch (error) {
      logApi.AddLog(`Errore durante l'aggiornamento alla versione ${info.version} sull'utente ${currentUserModel.userId}`,"","handleModalOkVersion","Dashboard")
    }
    setIsLastVersionModalShow(false);
  };
  const handleModalVersionErrorOk = async () => {
    setIsVersionCorrect(true);
  };
  //#endregion

  //#region Modal Duplicates Anagrafiche
  const canFixDuplicates = duplicatesManipulation.authorized && anagraficaPermissions.canUpdate && anagraficaPermissions.canDelete;
  const canFixCurrentDuplicates = () => {
    const permissions = getAnagraficaPermissions();
    return duplicatesManipulation.authorized && permissions.canUpdate && permissions.canDelete;
  };
  const handleDeleteDoubleAnagrafica = (props) => {
    if (!canFixCurrentDuplicates()) return;
    if (props && props.groupedDuplicates && props.selections) {
      setPendingDeletionData(props);
      setIsDuplicatesModalVisible(false);
      setIsDeleteConfirmModalVisible(true);
    }
  };
  const handleConfirmDelete = async () => {    
    setIsDeleteConfirmModalVisible(false);
    if (!canFixCurrentDuplicates()) {
      setPendingDeletionData(null);
      return;
    }
    if (pendingDeletionData && pendingDeletionData.groupedDuplicates && pendingDeletionData.selections) {
      let notDeletedDuplicates = [];
      for (let i = 0; i < pendingDeletionData.groupedDuplicates.length; i++) {
        //Per ogni gruppo di duplicati dobbiamo prendere gli id da eliminare e l'unico id da mantenere
        if (
          pendingDeletionData.selections[i] === null ||
          pendingDeletionData.selections[i] === undefined
        ) {
          //L'utente non ha selezionato nulla per questo gruppo, salto
          continue;
        }
        let group = pendingDeletionData.groupedDuplicates[i];
        let idToKeep = group.duplicates[pendingDeletionData.selections[i]].id;
        let idsToDelete = group.duplicates
          .filter((anag) => anag.id !== idToKeep)
          .map((anag) => anag.id);

        try {
          if (!canFixCurrentDuplicates()) {
            setPendingDeletionData(null);
            return;
          }
          let deleteResponse = await anagraficaApi.DeleteDuplicatesAnagrafiche(
            idToKeep,
            idsToDelete
          );
          if (!deleteResponse.success) {
            notDeletedDuplicates.push(idToKeep);
          }
        } catch (error) {
          logApi.AddLog(error.message,error.stack,"handleConfirmDelete","Dashboard");
          notDeletedDuplicates.push(idToKeep);
          enqueueSnackbar(t("error.generale"), { variant: "error" });
        }
      }
      if (notDeletedDuplicates.length === 0) {
        enqueueSnackbar("Tutti i duplicati sono stati eliminati correttamente",{ variant: "success" });
      } else {
        enqueueSnackbar("Alcuni duplicati non sono stati eliminati, riprova più tardi",{ variant: "warning" });
      }
    }

    // Ricarica i duplicati aggiornati
    try {
      let duplicatesManip = await anagraficaApi.CheckIfThereAreDuplicates();
      setDuplicatesManipulation(duplicatesManip);
      let allDuplicates = await anagraficaApi.GetDuplicateAnagrafica();
      setDuplicatesAnags(allDuplicates);

      // Se ci sono ancora duplicati, riapri la modale duplicati
      if (allDuplicates.length > 0) {
        setIsDuplicatesModalVisible(true);
      } else {
        // Se non ci sono più duplicati, chiudi definitivamente
        setIsDuplicatesModalVisible(false);
        sharedDatas.setPropertyValue("duplicatesModalAlreadyShown", true);
      }
    } catch (error) {
      logApi.AddLog(
        error.message,
        error.stack,
        "handleConfirmDelete/reload",
        "Dashboard"
      );
    }

    // Resettiamo i dati temporanei
    setPendingDeletionData(null);
  };
  const handleCancelDelete = () => {
    setIsDeleteConfirmModalVisible(false);
    setPendingDeletionData(null);
    setIsDuplicatesModalVisible(true);
  };
  const handleCloseDuplicatesModal = () => {
    setIsDuplicatesModalVisible(false);
    sharedDatas.setPropertyValue("duplicatesModalAlreadyShown", true);
  };
  const handleReopenDuplicatesModal = () => {
    setIsDuplicatesModalVisible(true);
  };
  //#endregion

  //#region Return graphics
  return (
    <Fragment>
      <Dialog
        open={!!blockingErrorMessage}
        disableEscapeKeyDown
        sx={{ "& .MuiDialog-paper": { minWidth: 400 } }}
      >
        <DialogTitle>Attenzione</DialogTitle>
        <DialogContent>
          <Typography>{blockingErrorMessage}</Typography>
        </DialogContent>
      </Dialog>
      {isLastVersionModalShow && (
        <ModalVersion
          show={isLastVersionModalShow}
          onClose={handleModalVersionClose}
          onOk={handleModalVersionOk}
        />
      )}
      {!isVersionCorrect && (
        <ModalErrorVersion
          messageFromParent={message}
          show={!isVersionCorrect}
          onOk={handleModalVersionErrorOk}
        />
      )}
      {isUserLoaded && !tenantReadOnly && (
        <ModalFixDuplicate
          show={isDuplicatesModalVisible}
          duplicatesAnags={duplicatesAnags}
          tenantId={tenantId}
          isAuthorized={canFixDuplicates}
          userOwnerName={userOwnerName}
          blocking={blockingDuplicates && canFixDuplicates}
          onOk={handleDeleteDoubleAnagrafica}
          onClose={handleCloseDuplicatesModal}
        />
      )}
      <ModalDelete
        show={isDeleteConfirmModalVisible}
        onClose={handleCancelDelete}
        onOk={handleConfirmDelete}
        deleteMessage={
          "Vuoi confermare l'eliminazione delle anagrafiche non selezionate? Questa operazione è irreversibile"
        }
      />
      <Loading open={backDropOpen} />
      {isUserLoaded && isDataLoaded ? (
        <Stack
          direction="column"
          spacing={2}
          sx={{
            p: { xs: 1.5, md: 2 },
            height: "100% !important",
            background: "hsl(199, 15%, 95%)",
          }}
        >
          <Stack
            direction="column"
            spacing={2}
            sx={{
              width: "100%",
              maxWidth: { xl: 1720 },
              mx: "auto",
            }}
          >
            <DashboardHeader
              user={user}
              lastActivity={lastActivity}
              hasMalformedPiva={hasMalformedPiva}
              duplicatesAnags={duplicatesAnags}
              duplicatesManipulation={duplicatesManipulation}
              blockingDuplicates={blockingDuplicates}
              userRespAntiricName={userRespAntiricName}
              respAntiricPermsError={respAntiricPermsError}
              livelloS={livelloS}
              livelloC={livelloC}
              message={message}
              onLastActivityClick={handleLastActivityClick}
              onGoToErrAnag={handleGoToErrAnag}
              onReopenDuplicatesModal={handleReopenDuplicatesModal}
            />
            <DashboardCharts
              user={user}
              statsFascicoliData={statsFascicoliData}
              statsPfPgData={statsPfPgData}
              statsPrestData={statsPrestData}
              statsRischiData={statsRischiData}
              entityCounters={entityCounters}
              onGoToFascicoloHome={handleGoToFascicoloHome}
              onGoToAnagraficaHome={handleGoToAnagraficaHome}
              onGoToPrestazioneHome={handleGoToPrestazioneHome}
              onGoToValutazioneHome={handleGoToValutazioneHome}
            />
            <DashboardImport
              isARicDesktopActive={isARicDesktopActive}
              onGoToImportDesktop={handleGoToImportDesktop}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{ my: { xs: 2, md: 3 } }}
            >
              <DashboardExpirations
                anagDocInScadList={anagDocInScadList}
                anagDocInScadListColumns={anagDocInScadListColumns}
                rischiList={rischiList}
                rischiColumns={rischiColumns}
                autovalList={autovalList}
                autovalColumns={autovalColumns}
                onGoToAnagrafica={handleGoToAnagrafica}
                onGoToRischio={handleGoToRischio}
              />
              <DashboardFascicoli
                fascicoliIncompleteList={fascicoliIncompleteList}
                fascicoliIncompleteColumns={fascicoliIncompleteColumns}
                fascicoliCompleteList={fascicoliCompleteList}
                fascicoliCompleteColumns={fascicoliCompleteColumns}
                onGoToFascicolo={handleGoToFascicolo}
              />
            </Stack>
          </Stack>
        </Stack>
      ) : null}
    </Fragment>
  );
  //#endregion
};
